// Google Analytics 4 helpers. Safe no-ops if gtag isn't loaded (e.g. dev / ad-blockers).
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const GA_ID = "G-3PC2JR8FDT";

export function track(event, params = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", event, params);
  } catch (_) {
    /* noop */
  }
}

// Send a GA4 page_view whenever the SPA route changes.
export function usePageview() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    try {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    } catch (_) {
      /* noop */
    }
  }, [location.pathname, location.search]);
}
